import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class RemoteHandsRequestRoute extends Route {
  @service availableServices;

  beforeModel() {
    this.availableServices.requireAccessTo(this, "remote-hands");
  }
}
